<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline=""
          :link="[
            {
              text: 'Bộ môn',
              href: '/teachingDoc',
            },
            {
              text: 'Đề cương, tài liệu',
            },
          ]"
        />
      </div>
    </div>
    <div id="app">
      <div v-if="isLoading" class="center-screen">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div class="mx-4">
        <TreeNoteDocCat v-for="folder in docCategories" :key="folder.id" :folder="folder" />
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import { mapActions, mapState } from 'vuex'
import TreeNoteDocCat from '../../components/basic/tree/TreeNoteDocCat.vue'
export default {
  props: {
    academicLevelId: {
      type: String,
      default: null,
    },
  },
  components: {
    Breadcrumbs,
    TreeNoteDocCat,
  },
  data() {
    return {
      isLoading: true,
    }
  },

  computed: {
    ...mapState({
      docCategories(state) {
        return state['docCategory'].docCategories
      },
      profile(state) {
        return state['auth'].profile
      },
    }),
  },
  mounted() {
    this.initializeTeachingsTree()
  },
  methods: {
    ...mapActions({
      fetchTree: 'docCategory/fetchTree',
      fetchTeachings: 'teacherDoc/fetchTeachings',
    }),
    async initializeTeachingsTree() {
      this.isLoading = true
      try {
        const academicLevelId = this.$route.params.academicLevelId
        await this.fetchTree(academicLevelId)
      } catch (error) {
        console.error('Failed to fetch teachings data:', error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
<style scoped>
.center-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}
</style>
